export const toNumber = (value: unknown): number | undefined => {
  return typeof value === 'number'
    ? value
    : value
    ? Number(value as string)
    : undefined
}

export const toNumberArray = (value: unknown): number[] => {
  if (!value) return []

  if (!Array.isArray(value)) {
    return typeof value === 'string' ? [Number(value)] : []
  }

  return value.map((v) => Number(v))
}

export const toStringArray = (value: unknown): string[] => {
  if (!value) return []

  if (!Array.isArray(value)) {
    return typeof value === 'string' ? [value] : []
  }

  return value
    .map((v) => (typeof v === 'string' ? v : null))
    .filter(Boolean) as string[]
}

export const toBoolean = (value: unknown): boolean | undefined => {
  return typeof value === 'boolean'
    ? value
    : value
    ? value === 'true'
    : undefined
}
